// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".facesheet-index__container{margin-bottom:20px}.facesheet-index__content-spinner{padding-top:5em}.facesheet-index__subheader-container{background:var(--color-white);border-bottom:1px solid var(--color-table-rule);margin-bottom:50px}.facesheet-index .activity-stream-body{padding-top:20px;position:relative}", ""]);
// Exports
module.exports = exports;
